import { OverlayRectangle } from "assets/svg";
import classNames from "classnames";
import { QuestionInput } from "components/QuestionInput/QuestionInput";
import { QuestionMedia } from "components/QuestionMedia/QuestionMedia";
import { Timer } from "components/Timer/Timer";
import { useEffect, useMemo } from "react";
import { disableCopyPasteHandlers } from "utils/helper";
import "./spotlight-mcq.css"

const SpotlightMCQ = ({
    type,
    count,
    time,
    questionsCount,
    question,
    options,
    optionSubmitHandler,
    timeToSolve,
    isOffline,
    id,
    media,
    ...rest

}) => {
    const progressWidth = (Math.floor((count / questionsCount) * 100))
    const isHtml = /<\/?[a-z][\s\S]*>/i.test(question)

    const isOptionUpperCase = useMemo(() => {
        const sortedOptions = options.sort((option1, option2) => option2?.text?.length - option1?.text?.length)
        if (sortedOptions[0]?.text?.length < 20) {
            return true
        }
        return false
    }, [options])

    const questionClass = classNames("text-[#fff] w-[95%] text-[20px] font-light leading-[25px] break-words")

    useEffect(() => {
        document.body.style.fontFamily = "Martian Mono SemiExpanded"
    }, [])

    return (
        <div
            className={classNames("bg-[#000] spotlight-mcq-container h-[100vh] overflow-y-auto overflow-x-hidden relative")}>
            <span className={classNames("absolute z-[1] h-[100vh] overflow-y-hidden left-[0px] top-[0px] opacity-[.05]")}>
                <OverlayRectangle />
            </span>
            <div className={classNames("w-[70vh] h-[70vh] bg-[#181a1b] absolute rounded-full top-[100px] right-[-45vh]")} />
            <div className={classNames("flex items-center justify-between px-[25px] mt-[40px]")}>
                <div className={classNames("flex items-center mr-[20px]")}>
                    <p className={classNames("text-[28px] text-[#fff] font-medium")}>{count}</p>
                    <p className={classNames("text-[16px] text-[#fff] font-extralight opacity-70 ml-[2px]")}>/{questionsCount}</p>
                </div>
                <Timer time={time} type={type} isMcq={true} />
            </div>
            <div className={classNames("flex justify-center mt-[20px]")}>
                <div className={classNames("relative flex flex-col items-center p-[25px] ques-card z-[1] w-[95vw] rounded-[40px] backdrop-blur-2xl")}>
                    <div className={classNames("relative w-[95%] h-[5px] mb-[45px]")}>
                        <div className={classNames("absolute w-full h-full left-0 top-0 progress-track rounded-[20px]")} />
                        <div style={{
                            width: `${progressWidth}%`
                        }} className={classNames(`progress-fill absolute h-full left-0 top-0 bg-[#8871E3] rounded-[20px]`)} />
                    </div>
                    {!isHtml ? (
                        <h2
                            className={questionClass}
                            {...disableCopyPasteHandlers}
                        >
                            {question.split("\n").map((sentence, index) =>
                                index > 0 ? (
                                    <>
                                        <br />
                                        {sentence}
                                    </>
                                ) : (
                                    sentence
                                )
                            )}
                        </h2>
                    ) : (
                        <div
                            className={classNames(questionClass, "html", {
                            })}
                            dangerouslySetInnerHTML={{ __html: isHtml ? question : null }}
                            {...disableCopyPasteHandlers}
                        />
                    )}
                    <div className="my-[30px]">
                        <QuestionMedia
                            media={media}
                            onMediaLoad={() => { }}
                            isMcq={true}
                            spotlightOrgFlag={true}
                        />
                    </div>
                    <QuestionInput
                        type={type}
                        questionId={id}
                        showGridView={false}
                        options={options}
                        isOptionTextLong={() => false}
                        onSubmit={optionSubmitHandler}
                        time={time}
                        timeToSolve={null}
                        isOffline={isOffline}
                        isOptionUpperCase={isOptionUpperCase}
                    />
                </div>
            </div>
        </div>
    )
}

export default SpotlightMCQ